import i18n from 'i18next';
import { invert } from 'lodash';
import { languages } from '../conf/i18n';

const langMap = invert(languages); // e.g. { 'en' : 'default' }
const keys = {
  default: 'nameLangDefault',
  altlang1: 'nameAltLangOne',
  altlang2: 'nameAltLangTwo',
};
const keysDiplomatic = {
  default: 'nameLangDefault',
  altlang1: 'nameLangOne',
  altlang2: 'nameLangTwo',
};
const errorKeys = {
  default: 'errorDefaultLang',
  altlang1: 'errorAltLangOne',
  altlang2: 'errorAltLangTwo',
};

export const toActiveLocale = (multiLangObj, lang = i18n.language) => {
  const activeLangKey = keys[langMap[lang]];
  return multiLangObj[activeLangKey] || multiLangObj.nameLangDefault;
};
export const toActiveLocaleDiplomatic = (
  multiLangObj,
  lang = i18n.language
) => {
  const activeLangKey = keysDiplomatic[langMap[lang]];
  return multiLangObj[activeLangKey] || multiLangObj.nameLangDefault;
};
export const errorInActiveLocale = (multiLangObj, lang = i18n.language) => {
  const activeLangKey = errorKeys[langMap[lang]];
  return multiLangObj[activeLangKey] || multiLangObj.errorDefaultLang;
};

export const getDropdownOptions = (optionList, lang) =>
  optionList.map(option => ({
    id: option.uuid,
    label: toActiveLocale(option, lang),
    value: option.uuid,
  }));
export const getDropdownOptionsDiplomatic = (optionList, lang) =>
  optionList.map(option => ({
    id: option.uuid,
    label: toActiveLocaleDiplomatic(option, lang),
    value: option.uuid,
  }));



// WEBPACK FOOTER //
// ./src/services/Translation.js